import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { useNotificationStore } from '@/stores/notifications';

export const downloadTableAsCSV = ({ messageId, token }) => {
  return axios.get(
    `/api/v1/agent/conversation/output/${messageId}/download${
      token ? `?token=${token}` : ''
    }`
  );
};

export const useDownloadTableAsCSV = ({ config } = {}) => {
  const { addNotification } = useNotificationStore();

  return useMutation(downloadTableAsCSV, {
    onError: (error) => {
      addNotification({
        type: 'error',
        title: error.response.data.error.message || 'Error fetching CSV',
      });
    },
    ...config,
  });
};
